import svg from './row-svg/kozikaza-v1.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function KozikazaV1Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default KozikazaV1Icon;
